export default {"src":"/_next/static/media/CMC.cc304ae8.svg","height":18,"width":18};